import React from 'react'
import classNames from 'classnames'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

interface PrivacyStatementProps {
  hidden?: boolean
  variation?: 'otl-dark' | 'otl-light'
  font?: 'serif' | 'sans-serif'
  center?: boolean
}

const PrivacyStatement = ({
  hidden,
  variation = 'otl-light',
  font = 'sans-serif',
  center
}: PrivacyStatementProps) => {
  const { t } = useI18next()
  const containerCss = classNames('text-xs pb-4', {
    'font-calibre': font === 'sans-serif',
    'font-serif': font === 'serif',
    'text-white': variation === 'otl-dark',
    'text-legacy-grey-10': variation === 'otl-light',
    'text-center': center,
    hidden
  })

  return (
    <p className={containerCss}>
      {t(
        `By submitting, you agree to receive marketing emails from Toast. We’ll handle your info according to our`
      )}{' '}
      <a href='/privacy' className='text-toast-orange-500'>
        {t(`privacy statement`)}
      </a>
      {t(`. Additional information for California residents available`)}{' '}
      <a href='/privacy#addendum-a' className='text-toast-orange-500'>
        {t(`here`)}
      </a>
    </p>
  )
}

export default PrivacyStatement
